import { jsx as e } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import r from "@mui/material/MenuList";
import n from "styled-components";
const a = {
  root: "menuListRoot"
}, m = n(r).withConfig({
  displayName: "StyledMenuList"
})([
  "&&.menuListRoot{width:auto;padding:8px;}"
]), u = /* @__PURE__ */ i(({ children: t, ...o }, s) => /* @__PURE__ */ e(m, {
  ...o,
  ref: s,
  classes: a,
  children: t
}));
u.displayName = "MenuList";
export {
  u as default
};
